var map = {
	"./MDX.png": [
		668,
		11
	],
	"./bch.png": [
		669,
		12
	],
	"./bnb-busd.png": [
		670,
		13
	],
	"./bnb.png": [
		671,
		14
	],
	"./bsv.png": [
		672,
		15
	],
	"./busd (2).png": [
		673,
		16
	],
	"./busd.png": [
		674,
		17
	],
	"./can.png": [
		675,
		18
	],
	"./dh.png": [
		676,
		19
	],
	"./dot.png": [
		677,
		20
	],
	"./edc.png": [
		678,
		21
	],
	"./eth-busd.png": [
		679,
		22
	],
	"./eth.png": [
		680,
		23
	],
	"./fil.png": [
		681,
		24
	],
	"./hbtc.png": [
		682,
		25
	],
	"./hpt.png": [
		683,
		26
	],
	"./hqtum.png": [
		684,
		27
	],
	"./ht.png": [
		685,
		28
	],
	"./husd.png": [
		686,
		29
	],
	"./initlogo.png": [
		687,
		30
	],
	"./ltc.png": [
		688,
		31
	],
	"./usdc.png": [
		689,
		32
	],
	"./usdt-best.png": [
		690,
		33
	],
	"./usdt-busd.png": [
		691,
		34
	],
	"./usdt.png": [
		692,
		35
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 269;
module.exports = webpackAsyncContext;